import { UserService } from "../api";
import { useQuery, type UseQueryResult } from "react-query";
import { useTypedSelector } from "../redux/store";
import { type UserResult } from "../api/generated/data-contracts";
interface Props {
  auth0Id: string;
}

export const useGetUser = ({
  auth0Id
}: Props): UseQueryResult<UserResult, unknown> => {
  const userJwt = useTypedSelector((state) => state.auth.value);
  return useQuery({
    queryKey: ["getUser", auth0Id],
    queryFn: async () => {
      const response = await UserService.userDetail(auth0Id, {
        headers: {
          Authorization: `Bearer ${userJwt}`
        }
      });
      return response.data;
    },
    enabled: !!userJwt,
    refetchOnWindowFocus: false
  });
};
